module.exports = __webpack_public_path__ + "media/icons/key-i-2e13d735.svg";